import Modal from "./Modal";
import Button from "./Button";
import { useRouteHelper } from "../utils/RouteHelper";

const DupicateUserErrorModal = () => {
  const { goLogin } = useRouteHelper();
  return (
    <Modal title="Invalid Access Code">
      <p className="text-xs text-left w-full mb-5">
        A user with this email already exists, please log in.
      </p>
      <Button
        text="BACK TO LOGIN"
        backgroundColor="bg-empathED-blue"
        onClick={goLogin}
      ></Button>
    </Modal>
  );
};

export default DupicateUserErrorModal;